
import { Link, useLocation } from "react-router-dom";
import { Container, Button } from "reactstrap";

import {
    FiCheckCircle,
    FiHome,
    FiPhone,
    FiMail,
} from "react-icons/fi";

import "./ThankYouPage.css";

function ThankYouPage() {

    const location = useLocation();
// eslint-disable-next-line
    const courseName = location.state?.courseName || "";

    return (
        <section className="thank-you-page">

            <Container>

                <div className="thank-you-card">

                    {/* =====================================
                        SUCCESS
                    ===================================== */}

                    <div className="thank-you-success-icon">
                        <FiCheckCircle />
                    </div>

                    <div className="thank-you-badge">
                        ENQUIRY SUBMITTED
                    </div>

                    <h1>
                        Thank You!
                    </h1>

                    <h2>
                        We've received your enquiry.
                    </h2>

                    <p className="thank-you-description">
                        Our team will get in touch with you shortly.
                    </p>


                    {/* =====================================
                        COURSE
                    ===================================== */}

                    {/* {courseName && (
                        <div className="thank-you-course">

                            <span>
                                Enquiry For
                            </span>

                            <strong>
                                {courseName}
                            </strong>

                        </div>
                    )} */}


                    {/* =====================================
                        CONTACT DETAILS
                    ===================================== */}

                    <div className="thank-you-contact">

                        <h3>
                            Need immediate assistance?
                        </h3>

                        <div className="thank-you-contact-list">

                            {/* PHONE / WHATSAPP */}

                            <div className="thank-you-contact-item">

                                <div className="thank-you-contact-icon">
                                    <FiPhone />
                                </div>

                                <div className="thank-you-contact-content">

                                    <span>
                                        Call Us or WhatsApp
                                    </span>

                                    <a href="tel:+918884442747">
                                        +91 888 444 2747
                                    </a>

                                    <a href="tel:+918884442151">
                                        +91 888 444 2151
                                    </a>

                                </div>

                            </div>


                            {/* EMAIL */}

                            <div className="thank-you-contact-item">

                                <div className="thank-you-contact-icon">
                                    <FiMail />
                                </div>

                                <div className="thank-you-contact-content">

                                    <span>
                                        Email Us
                                    </span>

                                    <a href="mailto:contact@feesworth.com">
                                        contact@feesworth.com
                                    </a>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* =====================================
                        HOME BUTTON
                    ===================================== */}

                    <div className="thank-you-actions">

                        <Button
                            tag={Link}
                            to="/"
                            className="thank-you-home-button"
                        >
                            <FiHome />
                            Back to Home
                        </Button>

                    </div>


                    {/* =====================================
                        FOOTER
                    ===================================== */}

                    <div className="thank-you-footer">
                        FeesWorth Online Training
                    </div>

                </div>

            </Container>

        </section>
    );
}

export default ThankYouPage;